import React from 'react'
import FanSelectionForm from '../FanSelectionForm'

interface FanSelectionTabProps {
  calculatedSupplyAirflow: number
  calculatedReturnAirflow: number
}

const FanSelectionTab: React.FC<FanSelectionTabProps> = React.memo(({
  calculatedSupplyAirflow,
  calculatedReturnAirflow
}) => {
  return (
    <FanSelectionForm
      calculatedSupplyAirflow={Math.round(calculatedSupplyAirflow)}
      calculatedReturnAirflow={Math.round(calculatedReturnAirflow)}
    />
  )
}, (prevProps, nextProps) => {
  // 반올림된 값이 같으면 리렌더링 방지 (성능 최적화)
  return (
    Math.round(prevProps.calculatedSupplyAirflow) === Math.round(nextProps.calculatedSupplyAirflow) &&
    Math.round(prevProps.calculatedReturnAirflow) === Math.round(nextProps.calculatedReturnAirflow)
  );
});

FanSelectionTab.displayName = 'FanSelectionTab';

export default FanSelectionTab